import {
  Pause as AccidentIcon,
  NotificationImportant as AlarmIcon,
  TextSnippet as DefaultIcon,
  LocalFireDepartment as FireIcon,
  FormatPaint as GraffitiIcon,
  Place as LocationIcon,
  MedicalServices as MedicalIcon,
  Groups as PeopleIcon,
  GppGood as RequestedCheckupIcon,
  MapsHomeWork as SiteIcon,
  DirectionsCar as VehicleIcon,
} from '@mui/icons-material';
import { TimelineDot } from '@mui/lab';

export const getTimeLineDot = (what: string): JSX.Element => {
  switch (what) {
    case 'Accident':
      return (
        <TimelineDot color="warning">
          <AccidentIcon />
        </TimelineDot>
      );
    case 'Alarm activated':
      return (
        <TimelineDot color="warning">
          <AlarmIcon />
        </TimelineDot>
      );
    case 'Dodgy people looking shifty':
      return (
        <TimelineDot>
          <PeopleIcon />
        </TimelineDot>
      );
    case 'Fire':
      return (
        <TimelineDot color="warning">
          <FireIcon />
        </TimelineDot>
      );
    case 'Graffiti':
      return (
        <TimelineDot color="warning">
          <GraffitiIcon />
        </TimelineDot>
      );
    case 'Location':
      return (
        <TimelineDot>
          <LocationIcon />
        </TimelineDot>
      );
    case 'Medical assistance':
      return (
        <TimelineDot color="warning">
          <MedicalIcon />
        </TimelineDot>
      );
    case 'Requested checkup/visit':
      return (
        <TimelineDot color="success">
          <RequestedCheckupIcon />
        </TimelineDot>
      );
    case 'Site check':
      return (
        <TimelineDot>
          <SiteIcon />
        </TimelineDot>
      );
    case 'Vehicle check':
      return (
        <TimelineDot>
          <VehicleIcon />
        </TimelineDot>
      );
    default:
      return (
        <TimelineDot>
          <DefaultIcon />
        </TimelineDot>
      );
  }
};
